import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TimeoutError } from '@softline/core';
import { Observable, throwError, timeout } from 'rxjs';

const REQUEST_TIMEOUT_MS = 10_000;

@Injectable()
export class StempelTerminalTimeoutInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('pms/stempelterminal/stempeln')) return next.handle(req);
    return next.handle(req).pipe(
      timeout({
        each: REQUEST_TIMEOUT_MS,
        with: throwError(() => new TimeoutError(REQUEST_TIMEOUT_MS)),
      } as any)
    ) as any;
  }
}
